<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label-for="formControlId" v-bind="$attrs">
        <template v-slot:label>
            <template v-if="label">
                {{ label }}
                <csp-form-tooltip :tooltip="tooltip"/>
            </template>
        </template>
        <csp-form-select-searchable-with-tags
            :id="formControlId"
            v-model="data[property]"
            :allow-empty="!isRequiredProperty"
            :auto-select-single-option="autoSelectSingleOption"
            :disable-change-trigger="disableChangeTrigger"
            :disabled="isReadOnlyProperty || dependencyDisabled"
            :options="internalOptions"
            :options-loader="optionsLoader"
            :placeholder="placeholder"
            :property="property"
            :reset-after="resetAfter"
            :state="validationState"
            :value-empty="valueEmpty"
            @change="handleSelect"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from './FormGroupMixin';
    import SelectSearchableWithTags from './SelectSearchableWithTags';
    import LazySelectOptionsMixin from './mixins/LazySelectOptionsMixin';
    import DependentSelectMixin from '@components/form/mixins/DependentSelectMixin'

    export default {
        name: 'FormGroupSelectSearchable',
        components: {
            'csp-form-select-searchable-with-tags': SelectSearchableWithTags,
        },
        mixins: [FormGroupMixin, LazySelectOptionsMixin, DependentSelectMixin],
        props: {
            valueEmpty: {
                type: null,
                default: null,
            },
            disableChangeTrigger: {
                type: Boolean,
                default: false,
            },
            autoSelectSingleOption: {
                type: Boolean,
                default: false,
            },
            resetAfter: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change', 'changeOption'],
        computed: {
            placeholder() {
                if (this.hideLabel) {
                    return this.labelTranslation;
                }
                return this.$t('form.multiselect.placeholder');
            },
        },
        methods: {
            handleSelect(option) {
                this.$emit('change', option ? option.value : null);
                this.$emit('changeOption', option);
            },
        },
    }
</script>
